import type { Data } from '../../../types.tsx';
import type { Props } from '../types.tsx';
import { fetchData } from './fetch-data/index.tsx';

const getData = async ({ preferenceKey }: Props): Promise<Data> => {
	try {
		const result = await fetchData(preferenceKey);
		return {
			value: result,
		};
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (e: any) {
		if (e.statusCode === 404) {
			return { value: undefined };
		}
		throw e;
	}
};

export default getData;
